export default __webpack_public_path__ + "static/Automation-Solutions-04fe8b7ec9e9e8fdb0c9ccb7057480fc.webp";